import React, { useCallback, useRef, useState } from 'react';
import {
  FavoritesModal,
  Heading,
  Icons,
  IconSpinner,
  SecondaryButton,
  TalentListingCard,
} from '../../../../components';
import {
  capitalizeFirstSpacer,
  cardRenderSizes,
  formatStringtoCamelCase,
  getFirstListingImageUrl,
  getStateName,
  isArrayLength,
} from '../../../../util/genericHelpers';
import { FormattedMessage } from 'react-intl';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../../util/routes';
import {
  EditListingParamsType,
  EditListingTab,
  SectionGroupHeroTabs,
  SectionHeroTabs,
  SUBSCRIPTION_TYPES,
  SubscriptionStatus,
} from '../../../../util/enums';
import { useListingPageContext } from '../../context/ListingPageContext';
import SchoolWhiteLabelBanner from './SchoolWhiteLabelBanner';
import SchoolInlineBanner from './SchoolInlineBanner';
import Slider from 'react-slick';
import {
  getSubscriptionForListing,
  getUserSubscription,
  getUserSubscriptionLookupkeys,
  retrieveUserFavoritesList,
} from '../../../../util/userDataExtraction';

import css from './SectionSchoolHero.module.css';
import '../../../../styles/slick/slick.css';
import '../../../../styles/slick/slick-theme.css';
import RenderCouponOffer from '../../SharedComponents/RenderCouponOffer';
import RenderPerks from '../../SharedComponents/RenderPerks';
import RenderCampaigns from '../../SharedComponents/RenderCampaigns';
import RenderJobPost from '../../SharedComponents/RenderJobPost';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsAuthenticated } from '../../../../ducks/auth.duck';
import { currentUserListingSelector, userSelector } from '../../../../ducks/user.duck';
import { subscriptionPlanSelector } from '../../../../ducks/stripe.duck';
import RenderUserSubscriptionMaybe from '../../../EditListingPage/EditListingWizard/EditListingTalentPlusPanel/RenderUserSubscriptionMaybe/RenderUserSubscriptionMaybe';
import SectionGroupPlus from './SectionGroupPlus';
import { divisionOptions } from '../../../../config/configExtras';
import {
  deleteItemFromFavorites,
  favoritesSelector,
} from '../../../FavoritesPage/FavoritesPage.duck';
import { useConfiguration } from '../../../../context/configurationContext';
import { createSlug } from '../../../../util/urlHelpers';
import { setListingSessionUrl } from '../../../../util/helperFunction';
import {
  getListingAssociatedUsers,
  getListingSports,
} from '../../../../util/listingDataExtraction';
import { associatedListingsSelector } from '../../ListingPage.duck';

const SectionSchoolHero = (props, {}) => {
  const {
    publicData,
    isOwnListing,
    listing,
    showInlineBanners,
    currentAuthor,
    authorId,
    onSubmitInquiry,
    setOpenSocialSharingModal = () => {},
  } = useListingPageContext();

  const { isMobileLayout, intl, viewport } = props;
  const { title = '', description = '' } = listing?.attributes || {};

  const {
    state,
    city,
    zipCode,
    customLinks,
    conference,
    pub_conference,
    division,
    pub_division,
    pub_user_type_sct,
  } = publicData || {};

  const params = useParams();
  const history = useHistory();
  const config = useConfiguration();
  const dispatch = useDispatch();
  const routeConfiguration = useRouteConfiguration();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const { subscriptionPrices } = useSelector(subscriptionPlanSelector);
  const lookupKeys = getUserSubscriptionLookupkeys(currentAuthor);
  const currentUser = useSelector(userSelector);
  const { removedItemId } = useSelector(favoritesSelector);
  const currentUserListing = useSelector(currentUserListingSelector);
  const associatedListings = useSelector(associatedListingsSelector);
  const [activeFavoriteId, setActiveFavoriteId] = useState(null);

  const openFavoritesModal = id => setActiveFavoriteId(id);
  const currentUserListingSports = getListingSports(currentUserListing);

  const onRedirectPage = (page, pageParams = {}) => {
    history.push(createResourceLocatorString(page, routeConfiguration, pageParams, {}));
  };

  const [activeTab, setActiveTab] = useState(SectionHeroTabs.ABOUT);
  const sectionRefs = useRef({});

  const groupPlusMaybe = Boolean(
    getUserSubscription(listing?.author) === SUBSCRIPTION_TYPES.GROUP_PLUS
  );
  const scrollToSection = tab => {
    const sectionRef = sectionRefs.current[tab];
    if (sectionRef) {
      sectionRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleTabClick = tab => {
    setActiveTab(tab);
    scrollToSection(tab);
  };

  const renderInfo = (label, value, icon = null) => (
    <p>
      <span className={css.serviceLabel}>
        <Icons name={icon || formatStringtoCamelCase(label)} /> {label ? `${label}: ` : ''}
      </span>
      <span>{value || 'N/A'}</span>
    </p>
  );
  const currentUserId = currentUser?.id?.uuid;

  const profileImageURL = getFirstListingImageUrl(listing);
  const associatedUsers = getListingAssociatedUsers(listing);
  const isCurrentUserLinkedToListing = associatedUsers?.some(
    user => user?.talentId === currentUserId
  );
  const sharedProps = {
    isMobileLayout,
    intl,
    viewport,
    profileImageIcon: profileImageURL,
    currentUserListingSports,
    isCurrentUserLinkedToListing,
  };

  const divisionMaybe = division || pub_division;

  const selectedDivision = divisionMaybe
    ? divisionOptions.find(e => e.key === divisionMaybe)
    : null;

  const tabs = Object.values(SectionGroupHeroTabs);
  // const tabs = groupPlusMaybe ? Object.values(SectionGroupHeroTabs) : [SectionGroupHeroTabs.HOME];
  const listingId = listing?.id?.uuid;

  const currentUserSubscription = getSubscriptionForListing(currentUser, listingId);

  const isCurrentUserSubscriptionActive =
    isArrayLength(currentUserSubscription) &&
    currentUserSubscription?.some(sub => sub.status === SubscriptionStatus.ACTIVE);
  const hasAccess = isOwnListing || (isAuthenticated && isCurrentUserSubscriptionActive);
  const isGroupPlusTab = activeTab === SectionGroupHeroTabs.GROUP_PLUS;
  const showGroupPlusData = hasAccess && isGroupPlusTab && groupPlusMaybe;
  const shouldShowGroupPlusBanner =
    !isOwnListing &&
    (!isAuthenticated || !isCurrentUserSubscriptionActive) &&
    [SectionGroupHeroTabs.GROUP_PLUS, SectionGroupHeroTabs.SUBSCRIPTION].includes(activeTab);
  const favorites = retrieveUserFavoritesList(currentUser) || [];
  const favoritesList = favorites || [];
  const isAlreadyAddedToFavoriteslist =
    isArrayLength(favoritesList) &&
    favoritesList.some(category => category.ids?.includes(listingId));
  const firstImage = isArrayLength(listing?.images) ? listing.images[0] : null;
  const listingTitle = listing?.attributes?.title || '';
  const slug = createSlug(listingTitle);
  const navigateToLogin = () => {
    history.push(createResourceLocatorString('LoginPage', routeConfiguration, {}, {}));
    setListingSessionUrl(
      createResourceLocatorString('ListingPage', routeConfiguration, { slug, id: listingId }, {})
    );
  };
  const handleFavoritesList = useCallback(
    async e => {
      e.preventDefault();
      e.stopPropagation();

      try {
        if (!isAuthenticated) {
          navigateToLogin();
        }
        if (isOwnListing) {
          history.push(createResourceLocatorString('FavoritesPage', routeConfiguration, {}));
          return;
        }

        if (isAlreadyAddedToFavoriteslist) {
          await dispatch(
            deleteItemFromFavorites({
              isAuthenticated,
              id: listingId,
              favorites,
              config,
              userId: currentUserId,
            })
          );
        } else {
          openFavoritesModal(listingId);
        }
      } catch (error) {
        console.error('Error while updating favorites:', error);
      }
    },
    [
      isOwnListing,
      isAlreadyAddedToFavoriteslist,
      history,
      routeConfiguration,
      dispatch,
      listingId,
      favorites,
      config,
      currentUserId,
      openFavoritesModal,
    ]
  );
  const handleContactUserClick = e => {
    e.preventDefault();
    onSubmitInquiry();
  };
  const contactActions = [
    {
      key: 'favorite',
      icon: 'star',
      labelId: 'SectionHero.favorite',
      onClick: handleFavoritesList,
      className: isAlreadyAddedToFavoriteslist ? css.favorited : undefined,
      ariaLabel: isAlreadyAddedToFavoriteslist ? 'Remove from favorites' : 'Add to favorites',
      showSpinner: removedItemId === listingId,
    },
    { icon: 'messageBox', label: 'Chat', onClick: isOwnListing ? null : handleContactUserClick },
    { icon: 'share', label: 'Share', onClick: () => setOpenSocialSharingModal(true) },
  ];
  const stateName = getStateName(state);
  const subscriptionRequiredBanner =
    shouldShowGroupPlusBanner && title && isGroupPlusTab ? (
      <div className={css.schoolPremierBanner}>
        <FormattedMessage
          id="SectionHero.talentBanner.message"
          values={{
            talentName: <strong>{title}</strong>,
          }}
        />
      </div>
    ) : null;
  const showInlineBanner = isGroupPlusTab && !groupPlusMaybe && isOwnListing;
  const showCampaignLisitngs = isOwnListing || isCurrentUserLinkedToListing;

  const componentsToRender = [
    RenderCouponOffer,

    // Only insert RenderCampaigns in the second position if allowed
    ...(showCampaignLisitngs ? [RenderCampaigns] : []),

    RenderPerks,
  ];

  return (
    <div className={css.heroWrapper}>
      <div className={css.heroContainer}>
        <div className={css.heroBg}>
          <div className={css.contentWidth}>
            {showInlineBanners && isMobileLayout ? (
              <SchoolWhiteLabelBanner listing={listing} />
            ) : null}

            <div className={css.heroContent}>
              <div className={css.heroContentHead}>
                <div className={css.heroContentHeadLeft}>
                  {profileImageURL && (
                    <div className={css.schoolImg}>
                      <img
                        src={profileImageURL}
                        alt={listing?.attributes?.title}
                        className={css.featuredImage}
                      />
                    </div>
                  )}
                  <Heading as="h1" rootClassName={css.heading}>
                    {publicData?.organizationName}
                  </Heading>
                  <div className={css.verifySec}>
                    <Icons name="verify" /> <FormattedMessage id="SchoolListingCard.verified" />{' '}
                    {`${capitalizeFirstSpacer(pub_user_type_sct)} ${
                      groupPlusMaybe ? 'Plus' : 'Standard'
                    }`}
                  </div>
                </div>
                <div className={css.heroContentHeadRight}>
                  <div className={css.bookSessionSec}>
                    <div className={css.contactSec}>
                      {contactActions.map(
                        ({
                          key,
                          icon,
                          label,
                          labelId,
                          onClick,
                          className,
                          ariaLabel,
                          showSpinner,
                        }) => (
                          <button
                            key={key || icon}
                            type="button"
                            className={className}
                            onClick={onClick}
                            aria-label={ariaLabel || label}
                          >
                            {showSpinner ? <IconSpinner /> : <Icons name={icon} />}
                            {labelId ? <FormattedMessage id={labelId} /> : label}
                          </button>
                        )
                      )}
                    </div>
                  </div>
                  <div className={css.schoolInfo}>
                    <div className={css.otherDetails}>
                      {renderInfo('City', city, 'cityIcon')}
                      {renderInfo('State', stateName, 'location')}
                      {renderInfo('Division', selectedDivision?.value)}
                      {renderInfo('Conference', conference || pub_conference)}
                      {/* {renderInfo('Zip Code', zipCode, 'zipCode')} */}
                    </div>
                  </div>
                  {isArrayLength(customLinks) && groupPlusMaybe && (
                    <div className={css.keywordSec}>
                      <h2>
                        <FormattedMessage id="SectionHero.customLinks" />
                      </h2>
                      <div className={css.keywords}>
                        {customLinks.map((link, index) => (
                          <span key={index}>
                            <strong>
                              <a href={link?.url} target="_blank" rel="noopener noreferrer">
                                {link?.name}
                              </a>
                            </strong>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={css.heroContentImg}>
              {showInlineBanners && !isMobileLayout ? (
                <SchoolWhiteLabelBanner listing={listing} />
              ) : null}
              <div className={css.contentHeroTabs}>
                <div className={css.tabs}>
                  {tabs.map((tab, index) => (
                    <span
                      key={index}
                      className={tab === activeTab ? css.active : ''}
                      onClick={() => handleTabClick(tab)}
                    >
                      {tab}
                    </span>
                  ))}
                </div>

                {isOwnListing && (
                  <div className={css.editSec}>
                    <SecondaryButton
                      type="button"
                      onClick={() =>
                        onRedirectPage('EditListingPage', {
                          ...params,
                          type: EditListingParamsType.EDIT,
                          tab: EditListingTab.DETAILS,
                        })
                      }
                    >
                      <Icons name="pen" /> <FormattedMessage id="SectionHero.edit" />
                    </SecondaryButton>
                  </div>
                )}
              </div>
              {activeTab === SectionGroupHeroTabs.HOME && (
                <>
                  <div className={css.howItWorks}>
                    <div className={css.descriptionContainer}>{description}</div>
                  </div>

                  <RenderJobPost
                    isMobileLayout={isMobileLayout}
                    intl={intl}
                    viewport={viewport}
                    profileImageIcon={profileImageURL}
                    isCurrentUserLinkedToListing={isCurrentUserLinkedToListing}
                  />

                  {isArrayLength(associatedListings) && (
                    <div className={css.topCollectionsWrapper}>
                      <div className={css.sectionHead}>
                        <div className={css.leftSec}>
                          <h2>
                            <FormattedMessage id="SectionSchoolHero.exploreTalents" />
                          </h2>
                        </div>
                      </div>

                      <Slider {...talentSliderSettings}>
                        {associatedListings.map(listing => (
                          <TalentListingCard
                            className={css.listingCard}
                            key={listing.id.uuid}
                            listing={listing}
                            renderSizes={cardRenderSizes(false)}
                            isSectionSchoolHero
                            hideFavorite
                          />
                        ))}
                      </Slider>
                    </div>
                  )}

                  {componentsToRender.map((Component, index) => (
                    <Component key={index} {...sharedProps} />
                  ))}
                </>
              )}
              <SectionGroupPlus
                publicData={publicData}
                schoolInlineBanner={
                  <SchoolInlineBanner intl={intl} onRedirectPage={onRedirectPage} />
                }
                subscriptionRequiredBanner={subscriptionRequiredBanner}
                showGroupPlusData={showGroupPlusData}
                showInlineBanner={showInlineBanner}
              />
              {activeTab === SectionGroupHeroTabs.SUBSCRIPTION && (
                <RenderUserSubscriptionMaybe
                  lookupKeys={lookupKeys}
                  subscriptions={subscriptionPrices}
                  isListingPage={true}
                  isOwnListing={isOwnListing}
                  sectionRef={el => (sectionRefs.current[SectionGroupHeroTabs.SUBSCRIPTION] = el)}
                  authorId={authorId}
                  listingId={listingId}
                  currentUserSubscription={currentUserSubscription}
                />
              )}{' '}
              <FavoritesModal
                isOpen={!!activeFavoriteId}
                onClose={() => setActiveFavoriteId(null)}
                firstImage={firstImage}
                currentUserId={currentUserId}
                activeFavoriteId={activeFavoriteId}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const talentSliderSettings = {
  dots: false,
  arrows: true,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 3,
        variableWidth: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        variableWidth: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
      },
    },
  ],
};

SectionSchoolHero.defaultProps = {
  talentSliderSettings,
};

export default SectionSchoolHero;
